import { render } from "./DetalharDesconto.vue?vue&type=template&id=200508fd&scoped=true"
import script from "./DetalharDesconto.vue?vue&type=script&lang=js"
export * from "./DetalharDesconto.vue?vue&type=script&lang=js"

import "./DetalharDesconto.vue?vue&type=style&index=0&id=200508fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200508fd"]])

export default __exports__